import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import { CadastroGeral } from 'src/app/models/cadastro-geral.model';
import { daApi, MAP_CADASTRO_GERAL, paraApi } from '../api-map';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracaoService {

  constructor(
    private api: ApiService
  ) { }

  get(): Observable<any> {
    return this.api.get('/general-register').pipe(
      map((res: any) => res ? daApi(res, MAP_CADASTRO_GERAL) : new CadastroGeral())
    );
  }

  // Registro unico: o POST da API faz insere-ou-altera.
  patch(cadastroGeral: CadastroGeral): Observable<any> {
    return this.api.post('/general-register', paraApi(cadastroGeral, MAP_CADASTRO_GERAL));
  }

  postImage(file: File, url: string, fileName: string) {
    return this.api.postFile(file, url, fileName);
  }
}
